import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { find, first } from 'lodash';
import {
  Modal, Button, DropdownButton, MenuItem,
} from 'react-bootstrap';
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from 'react-json-pretty/dist/monikai';
import Toggle from 'react-bootstrap-toggle';
import DateTimeDisplay from '../../../../components/date-time-display';
import { getSubmittedParams as getOpportunitySubmittedParams } from '../../WinLossReducer';
import { getSubmittedParams as getAccountSubmittedParams } from '../../CEReducer';
import { translateNominationAccounts, translateNominationOpportunities } from '../../../../util/truvoice';
import { getIsSuperAdmin, getIsAdmin } from '../../../Auth/AuthReducer';
import styles from './styles.css';

import Log from './Log';

class LogModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedLogId: null,
      currentObject: null,
      viewRaw: false,
    };
    this.close = this.close.bind(this);
    this.handleSelectLog = this.handleSelectLog.bind(this);
    this.onToggleRaw = this.onToggleRaw.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const currentObject = this.props.object || {};
    const currentId = this.props.isAccount ? currentObject.account_id : currentObject.opportunity_id;
    const nextObject = nextProps.object || {};
    const nextId = nextProps.isAccount ? nextObject.account_id : nextObject.opportunity_id;
    if (currentId !== nextId && nextProps.object) {
      this.setState({ currentObject: nextObject });
    }
  }
  onToggleRaw() {
    this.setState({ viewRaw: !this.state.viewRaw });
  }

  handleSelectLog(selectedLogId) {
    this.setState({ selectedLogId });
  }

  close() {
    const { object } = this.props;
    if (object) {
      this.props.onClose(object);
      this.setState({ selectedLogId: null });
    }
  }

  renderLog() {
    const { logs, isAccount, program } = this.props;
    const { selectedLogId } = this.state;
    const activeLog = find(logs, { _id: selectedLogId }) || first(logs);
    if (logs.length === 0 || !activeLog) {
      return null;
    }
    return (<Log key={activeLog._id} log={activeLog} program={program} isAccount={isAccount} />);
  }

  renderSelector() {
    const { logs, isAdmin } = this.props;
    const { selectedLogId, viewRaw } = this.state;
    if (logs.length === 0) {
      return null;
    }
    const activeLog = find(logs, { _id: selectedLogId }) || first(logs) || {};
    const hasMultiple = logs.length > 1;
    return (
      <div className="well well-sm">
        <div className="clearfix">
          <div className="pull-left">
            Showing Submitted Data for
            {' '}
            {hasMultiple &&
              <DropdownButton
                onSelect={this.handleSelectLog}
                bsStyle="primary"
                bsSize="sm"
                title={<span><DateTimeDisplay value={activeLog.created_at} format="shortWithTime" /></span>}
                id="log-filter"
              >
                {logs.map(l => (
                  <MenuItem eventKey={l._id} key={l._id} active={activeLog._id === l._id}>
                    <span>
                      <DateTimeDisplay value={l.created_at} format="shortWithTime" />
                    </span>
                  </MenuItem>
                  ))}
              </DropdownButton>
            }
            {!hasMultiple && <DateTimeDisplay value={activeLog.created_at} format="shortWithTime" />}
          </div>
          {isAdmin &&
            <div className="pull-right text-right">
              Viewing
              {' '}
              <Toggle
                onClick={this.onToggleRaw}
                on={<span>Raw Parameters</span>}
                off={<span>Formatted Data</span>}
                size="xs"
                onstyle="success"
                offstyle="default"
                active={viewRaw}
              />
            </div>
          }
        </div>
      </div>
    );
  }

  renderRawLog() {
    const {
      logs, isAccount, program, isAdmin,
    } = this.props;
    if (!isAdmin) {
      return null;
    }
    const { selectedLogId } = this.state;
    const activeLog = find(logs, { _id: selectedLogId }) || first(logs);
    if (activeLog) {
      const action = isAccount ? translateNominationAccounts : translateNominationOpportunities;
      const data = action(program.client_id, program.program_id, activeLog.program_type, [activeLog]);
      return (
        <div className={styles.code}>
          <JSONPretty style={{ margin: 0 }} data={data} theme={JSONPrettyMon} />
        </div>
      );
    }
    return null;
  }

  render() {
    const { isOpen } = this.props;
    const { currentObject, viewRaw } = this.state;

    const hasObject = currentObject !== null && currentObject !== undefined;

    const title = hasObject ? currentObject.name : 'Submitted Data';

    return (
      <Modal show={isOpen} onHide={this.close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        {hasObject &&
          <Modal.Body>
            {this.renderSelector()}
            {!viewRaw && this.renderLog()}
            {viewRaw && this.renderRawLog()}
          </Modal.Body>
        }
        <Modal.Footer>
          <Button bsStyle="link" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

LogModal.propTypes = {
  object: PropTypes.shape({}),
  isAccount: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  logs: PropTypes.arrayOf(PropTypes.shape({})),
  program: PropTypes.shape({
    client_id: PropTypes.string.isRequired,
    program_id: PropTypes.string.isRequired,
  }).isRequired,
  isAdmin: PropTypes.bool.isRequired,
};
LogModal.defaultProps = {
  object: null,
  isAccount: false,
  isOpen: false,
  onClose: () => {},
  logs: [],
};

function mapStateToProps(state, ownProps) {
  let logs = [];
  if (ownProps.object) {
    const id = ownProps.isAccount ? ownProps.object.account_id : ownProps.object.opportunity_id;
    if (id) {
      const action = ownProps.isAccount ? getAccountSubmittedParams : getOpportunitySubmittedParams;
      logs = action(state, id);
    }
  }
  return {
    logs,
    isOpen: ownProps.object !== null && ownProps.object !== undefined,
    isAdmin: getIsSuperAdmin(state) || getIsAdmin(state),
  };
}


export default connect(mapStateToProps)(LogModal);
